/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 *  A stable empty array to facilitate React memoization.
 *  Use as a default for a null value instead of an inlined []
 *  when the distinction between [] and null is important (ex. loaded data)
 *
 *  This is especially important when the variable is a memoization dependency
 *  (ex. prop to a component, in a useCallback/useEffect/useMemo hook)
 *  */
// @ts-expect-error Necessary for this object to be reused in different contexts
export const EMPTY_ARRAY = Object.freeze([]) as Array<unknown> as Array<any>;

/**
 *  A stable empty object to facilitate React memoization.
 *  Use as a default for a null value instead of an inlined {}
 *  when the distinction between {} and null is important (ex. loaded data)
 *
 *  This is especially important when the variable is a memoization dependency
 *  (ex. prop to a component, in a useCallback/useEffect/useMemo hook)
 *  */
export const EMPTY_OBJECT = Object.freeze({}) as Record<any, any>;
export const EMPTY_OBJECT_NEVER = Object.freeze({}) as Record<any, never>;

/**
 *  A no-op function to be used to facilitate React memoization
 *  Use as a default for a null value instead of an inlined () => {}.
 *  Though, consider allowing null functions and carefully invoking via
 *  maybeFunc?.(...)
 *
 *  This is especially important when the variable is a memoization dependency
 *  (ex. prop to a component, in a useCallback/useEffect/useMemo hook)
 *  */ /**/
export const NOOP_FN = () => {};
export const NOOP_FN_PROMISE = (): Promise<any> => Promise.resolve();
